/* eslint-disable react-hooks/exhaustive-deps */
// 課金-ADD-START
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import i18n from "i18next";
import { connect } from "react-redux";
import { getWindow } from "ssr-window";
import Modal from "../../react-components/modal/index.js";

import { applicationBillingPlanCodeEnum, existStatusEnum } from "@/utils/enum";
import url from "@/utils/url";
import { isPOC } from "@/utils";

const PaymentSelectSection = ({ contractInfo, authorityType, history }) => {
  const isPayment =
    contractInfo?.applicationBillingPlanCode ===
    applicationBillingPlanCodeEnum.payment;
  const isAvaiable =
    contractInfo?.corporationBmServiceAvailabilityFlag ===
      existStatusEnum.existence &&
    authorityType === existStatusEnum.notExistence;
  const isFromContractTop = getWindow()?.sitecoreExternal?.isFromContractTop;
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (!isPOC() && authorityType !== existStatusEnum.other) {
      redirect();
    }
  }, [authorityType]);

  // リダイレクトの判定・実行
  const redirect = () => {
    const { replace } = history;
    if (!isAvaiable) {
      replace(url.forbidden);
    } else if (!isFromContractTop) {
      replace(url.payment);
    }
  };
 
  // ポップアップを閉じる
  const handleClose = () => setShowModal(false);

  // 戻る
  const back = () => {
    const { goBack } = history;
    goBack();
  };

  // 有料会員の場合は次画面に進む
  // 無料会員の場合はポップアップを開く
  const next = () => {
    const { push } = history;
    if (!isPayment) {
      setShowModal(true);  
    } else {
      push(url.paymentComparison);
    }
  };

  return (
    <>
      {isAvaiable && isFromContractTop && (
        <section className="payment-select-container">
          <p
            className="title"
            dangerouslySetInnerHTML={{
              __html: i18n.t("TCPs0002_payment_select_title"),
            }}
          />
          <p
            className="desc"
            dangerouslySetInnerHTML={{
              __html: i18n.t("TCPs0002_payment_select_desc"),
            }}
          />
          <div className="card-container">
            <div className={`card${isPayment ? " disabled" : ""}`}>
              <div
                className="recommend"
                dangerouslySetInnerHTML={{
                  __html: i18n.t("TCPs0002_payment_select_recommend"),
                }}
              />
              <p
                className="title"
                dangerouslySetInnerHTML={{
                  __html: i18n.t("TCPs0002_payment_select_payment_title"),
                }}
              />
              <p
                className="desc"
                dangerouslySetInnerHTML={{
                  __html: i18n.t("TCPs0002_payment_select_payment_desc"),
                }}
              />
              <div className="line" />
              <p
                className="amount"
                dangerouslySetInnerHTML={{
                  __html: i18n.t("TCPs0002_payment_select_payment_amount"),
                }}
              />
              <div
                className="remark"
                dangerouslySetInnerHTML={{
                  __html: i18n.t("TCPs0002_payment_select_payment_remark"),
                }}
              />
              <div className="bottom-line" />
              <div className={`bottom${isPayment ? " current" : ""}`}>
                {!isPayment && (
                  <img
                    src={require("@/assets/images/black-radio-selected.svg")}
                    alt=""
                  />
                )}
                <span
                  dangerouslySetInnerHTML={{
                    __html: i18n.t(
                      isPayment
                        ? "TCPs0002_payment_select_current"
                        : "TCPs0002_payment_select_radio_text"
                    ),
                  }}
                />
              </div>
            </div>
            <div className={`card${!isPayment ? " disabled" : ""}`}>
              <p
                className="title"
                dangerouslySetInnerHTML={{
                  __html: i18n.t("TCPs0002_payment_select_free_title"),
                }}
              />
              <p
                className="desc"
                dangerouslySetInnerHTML={{
                  __html: i18n.t("TCPs0002_payment_select_free_desc"),
                }}
              />
              <div className="line" />
              <p
                className="amount"
                dangerouslySetInnerHTML={{
                  __html: i18n.t("TCPs0002_payment_select_free_amount"),
                }}
              />
              <div
                className="remark"
                dangerouslySetInnerHTML={{
                  __html: i18n.t("TCPs0002_payment_select_free_remark"),
                }}
              />
              <div className="bottom-line" />
              <div className={`bottom${!isPayment ? " current" : ""}`}>
                {isPayment && (
                  <img
                    src={require("@/assets/images/black-radio-selected.svg")}
                    alt=""
                  />
                )}
                <span
                  dangerouslySetInnerHTML={{
                    __html: i18n.t(
                      !isPayment
                        ? "TCPs0002_payment_select_current"
                        : "TCPs0002_payment_select_radio_text"
                    ),
                  }}
                />
              </div>
            </div>
          </div>
          <div className="button-container">
            <button
              dangerouslySetInnerHTML={{
                __html: i18n.t("TCPs0002_payment_select_back"),
              }}
              onClick={back}
            />
            <button
              dangerouslySetInnerHTML={{
                __html: i18n.t("TCPs0002_payment_select_next"),
              }}
              onClick={next}
            />
          </div>
          <div>
            <Modal
              show={showModal}
              cancelText="閉じる"
              onCancel={handleClose}
              title={{
                __html: i18n.t("TCPs0002_payment_select_popup_desc"),
              }}
            />
          </div>
        </section>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    contractInfo: state?.user?.contractInfo,
    authorityType: state?.user?.authorityType,
  };
};

export default withRouter(connect(mapStateToProps)(PaymentSelectSection));
// 課金-ADD-END
